import { render, staticRenderFns } from "./engi_doc_create.vue?vue&type=template&id=72608a8e&scoped=true&"
import script from "./engi_doc_create.vue?vue&type=script&lang=js&"
export * from "./engi_doc_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72608a8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72608a8e')) {
      api.createRecord('72608a8e', component.options)
    } else {
      api.reload('72608a8e', component.options)
    }
    module.hot.accept("./engi_doc_create.vue?vue&type=template&id=72608a8e&scoped=true&", function () {
      api.rerender('72608a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_enginer/doc/create/engi_doc_create.vue"
export default component.exports